import { useApiClient } from "@/hooks/useApiClient";
import useSWRMutation, { type SWRMutationResponse } from "swr/mutation";

export interface ZipRequest {
  filePaths: string[];
}

export interface ZipResponse {
  presignedUrl: string;
  outputKey: string;
}

/**
 * 複数ファイルをZIP化するAPIを呼び出すSWR Mutationのフック。
 * @returns {SWRMutationResponse<ZipResponse, never, "/api/files/zip", ZipRequest>}
 */
export const useCreateZipWithFiles = (): SWRMutationResponse<
  ZipResponse,
  never,
  "/files/zip",
  ZipRequest
> => {
  const { apiClient } = useApiClient();
  const url = "/files/zip";

  const fetcher = async (
    url: string,
    { arg }: { arg: ZipRequest }
  ): Promise<ZipResponse> => {
    return (await apiClient.post<ZipResponse>(url, arg)).data;
  };

  return useSWRMutation(url, fetcher, { revalidate: false });
};
